// src/components/ProtectedRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from '../components/LoadingScreen';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Check if user has the required role
  // Modified to accept both 'admin' and 'owner' roles when required role is 'admin'
  const hasRequiredRole = () => {
    if (requiredRole === 'admin') {
      return user.role === 'admin' || user.role === 'owner';
    }
    return <Navigate to={`/${requiredRole || 'admin'}/login`} state={{ from: location }} replace />;

  };

  if (requiredRole && !hasRequiredRole()) {
    console.log('User role mismatch:', {
      userRole: user.role,
      requiredRole,
      hasAccess: hasRequiredRole()
    });
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;